import { AxiosRequestConfig } from 'axios'

import { CreateReplyTemplatePayload, UpdateReplyTemplatePayload } from './replyTemplateTypes'

const getReplyTemplates = (isAutomatic?: boolean): AxiosRequestConfig => ({
  url: '/reviews/reply-templates',
  method: 'GET',
  params: isAutomatic !== undefined ? { isAutomatic } : undefined,
})

const createReplyTemplate = (payload: CreateReplyTemplatePayload): AxiosRequestConfig => ({
  url: '/reviews/reply-templates',
  method: 'POST',
  data: payload,
})

const updateReplyTemplate = (payload: UpdateReplyTemplatePayload): AxiosRequestConfig => ({
  url: `/reviews/reply-templates/${payload.id}`,
  method: 'PATCH',
  data: {
    title: payload.title,
    body: payload.body,
    ...(payload.isAutomatic !== undefined ? { isAutomatic: payload.isAutomatic } : {}),
    ...(payload.isActive !== undefined ? { isActive: payload.isActive } : {}),
  },
})

const deleteReplyTemplate = (id: number): AxiosRequestConfig => ({
  url: `/reviews/reply-templates/${id}`,
  method: 'DELETE',
})

export { getReplyTemplates, createReplyTemplate, updateReplyTemplate, deleteReplyTemplate }
